import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

import { GalleryService } from '../../services/gallery.service';
import { TenantProfileResolve } from './tenant-profile.resolve';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileGalleriesResolve {
  private galleryService = inject(GalleryService);
  private tenantProfileResolve = inject(TenantProfileResolve);
  private platformId = inject<string>(PLATFORM_ID);

  async resolve() {
    if (isPlatformServer(this.platformId)) return [];
    const tenant = await this.tenantProfileResolve.resolve();
    const galleries = await this.galleryService.getTenantProfileGalleries(tenant.id);
    galleries.sort((a, b) => (a.last_changed_at < b.last_changed_at ? 1 : -1));
    return galleries;
  }
}
